import clientTab from './clientTab.vue';
import backManageTab from './backManageTab.vue';
export default {
  components: {
    clientTab,
    backManageTab
  },
  data() {
    return {
      activeKey: 'client'
    };
  },
  methods: {
    tabChange(e) {
      this.activeKey = e;
      if (e === 'client') {
        var _this$$refs$client;
        (_this$$refs$client = this.$refs.client) === null || _this$$refs$client === void 0 || _this$$refs$client.searchFun();
      }
      if (e === 'backManage') {
        var _this$$refs$backManag;
        (_this$$refs$backManag = this.$refs.backManage) === null || _this$$refs$backManag === void 0 || _this$$refs$backManag.searchFun();
      }
    }
  }
};